module.exports = __webpack_public_path__ + "static/media/IMG_5744-min.e7029c03.jpg";